<style lang="less">
    .submitOrder{
        width: 100%;
        height: auto;
        .order_title{
            width: 100%;
            height: 40px;
            display: flex;
            align-items: center;
            justify-content: center;
            // position: fixed;
            top: 0;
            left: 0;
            background-color: #fff;
            z-index: 1;
            font-size: 16px;
            .back{
                position: absolute;
                left: 10px;
                top: 8px;
            }
        }
        .order_content{
            width: 100%;
            padding: 5px 4% 15px;
            font-size: 14px;
            color: #666;
            box-sizing: border-box;
            margin: 40px 0 12px;
            .address_box{
                width: 100%;
                background-color: #fff;
                padding: 15px 4% 15px;
                box-sizing: border-box;
                border-radius: 8px;
                font-size: 12px;
                position: relative;
                >img{
                    width: 100%;
                    height: 8px;
                    position: absolute;
                    right: 0;
                    top: 0;
                }
                .topBg{
                    background-repeat: no-repeat;
                    background-size: cover;
                }
                .name{
                    margin-bottom: 6px;
                    font-size: 15px;
                    span{
                        font-size: 12px;
                        color: #ccc;
                        font-size: 13px;
                    }
                }
                .revise{
                    text-align: right;
                    color: #FF7C00;
                }
                .remarkContent{
                    >span{
                        display: inline-block;
                        margin-right: 6px;
                    }
                }
            }
            .cOrderList{
                width: 100%;
                height: auto;
                background-color: #fff;
                border-radius: 8px;
                padding: 8px 4% 0;
                box-sizing: border-box;
                margin-top: 12px;
                >p{
                    font-size: 12px;
                    color: #333;
                    font-weight:bold;
                    
                    padding-bottom: 8px;
                }
                ul{
                    li{
                        border-top: .5px solid #E0E0E0;
                        display: flex;
                        padding: 9px 0;
                        position: relative;
                        .price_num{
                            position: absolute;
                            right: 0;
                            top: 8px;
                            p{
                                text-align: right;
                                padding-bottom: 3px;
                            }
                            .needPay{
                                color: #333;
                            }
                        }
                        .pro_ipns{
                            .img_Box{
                                border-radius: 8px;
                                overflow: hidden;
                                img{
                                    width: 88px;
                                    height: 88px;
                                }
                            }
                            p{
                                padding: 4px 0;
                            }
                        }
                        .infoList{
                            margin-left: 15px;
                            color: #4D4D4D;
                            font-size: 12px;
                            >div{
                                &.brand_sub{
                                    font-size: 13px;
                                    color: #000;
                                    font-weight: bold;
                                }
                                display: flex;
                                align-items: center;
                                >span{
                                    display: inline-block;
                                    // min-width: 44px;
                                    text-align-last: justify;
                                }
                                margin-bottom: 3px;
                                >p{
                                    max-width: calc(100% - 44px);
                                    word-break: break-all;
                                    font-size: 14px;
                                }
                            }
                        }
                    }
                }
                .totalCount{
                    height: 36px;
                    border-top: 0.5px solid #E0E0E0;
                    display: flex;
                    justify-content: flex-end;
                    align-items: center;
                    p{
                        margin-left: 6px;
                        color: #333;
                        span{
                            color: #F36800;
                        }
                    }
                }
            }
            .order_list{
                margin-top: 10px;
                width: 100%;
                background-color: #fff;
                padding: 8px 15px 15px;
                box-sizing: border-box;
                border-radius: 8px;
                color: #333;
                font-size: 12px;
                .address{
                    margin-top: 4px;
                    color: #666;
                }
                .list{
                    display: flex;
                    justify-content: flex-start;
                    width: 100%;
                    flex-wrap: wrap;
                    margin-top: 20px;
                    li{
                        width: 30%;
                        margin: 0 5% 10px 0;
                        .imgBox{
                            height: 90px;
                            border-radius: 6px;
                            overflow: hidden;
                            img{
                                width: 100%;
                                height: 100%;
                            }
                        }
                        p{
                            display: flex;
                            justify-content: space-between;
                            margin-top: 4px;
                            align-items: center;
                            .num{
                                color: #999;
                            }
                        }
                        &:nth-of-type(3n){
                            margin: 0 0 10px;
                        }
                        
                    }
                }
            }

        }
        .order_foot{
            width: 100%;
            height: 50px;
            display: flex;
            justify-content: flex-end;
            align-items: center;
            box-sizing: border-box;
            padding: 0 10px;
            background-color: #fff;
            // position: fixed;
            bottom: 0;
            font-size: 14px;
            color: #484848;
            border-top: 0.5px solid #D3D5D5;border-radius: 0 0 12px 12px;
            >div{
                span{
                    display: inline-block;
                }
                .allNum{
                    margin-right: 10px;
                    color: #999;
                }
               .price{
                   font-size: 14px;
                   color: #E81E1C;
                   font-weight: bold;
                   span{
                       font-size: 16px;
                   }
               } 
               .btn{
                   width: 80px;
                   height: 30px;
                   line-height: 30px;
                   text-align: center;
                   background: linear-gradient(139deg, #FF923E 0%, #FF6F00 100%);
                   font-size: 13px;
                   color: #fff;
                   border-radius: 15px;
                   margin-left: 18px;
               }
            }
        }
        .Meng{
            position: fixed;
            left: 0;
            top: 0;
            z-index: 1;
            background-color: rgba(51,51,51,0.5);
            width: 100%;
            height: 100%;
        }
        .MengI{
            position: fixed;
            left: 0;
            top: 0;
            z-index: 2;
            background-color: rgba(51,51,51,0.5);
            width: 100%;
            height: 100%;
        }
        .payBox{
            position: fixed;
            bottom: 0;
            width: 100%;
            height: auto;
            z-index: 2;
            background-color: #fff;
            border-radius: 8px 8px 0 0;
            .pay_title{
                height: 44px;
                display: flex;
                position: relative;
                align-items: center;
                justify-content: center;
                font-size: 17px;
                border-bottom: 1px solid #E0E0E0;
                .noPay{
                    position: absolute;
                    left: 15px;
                    top: 10px;
                    width: 20px;
                    height: 20px;
                    
                    img{
                        width: 100%;
                        height: 100%;
                    }
                }
            }
            .allPrice{
                height: 84px;
                text-align: center;
                line-height: 84px;
                color:rgba(51,51,51,1);
                font-size: 20px;
                span{
                    font-size: 25px;
                    font-weight: bold;
                }
            }
            .payWay{
                box-sizing: border-box;
                padding: 0 15px;
                // li{
                //     border-bottom: 1px solid #E0E0E0;
                //     padding: 16px 0 10px;
                //     display: flex;
                //     font-size: 15px;
                //     color: #333;
                //     >div{
                //         width: 24px;
                //         height: 24px;
                //         margin-right: 12px;
                //         img{
                //             width: 100%;
                //             height: 100%;
                //         }
                //     }
                // }
                // 组件样式修改
                .van-cell{
                    padding: 10px 16px 10px 36px;
                    .van-cell__value{
                        position: initial;
                        >img{
                            position: absolute;
                            left: 0;
                        }
                        
                        
                    }
                    .van-radio{
                        .van-radio__icon--checked{
                            .van-icon{
                                background: linear-gradient(180deg, #FF923E 0%, #FF6F00 100%);
                                border-color: #FF923E;
                            }
                        }
                    }
                }
            }
            .paySubmit{
                width:330px;
                height:44px;
                background: linear-gradient(137deg, #FF923E 0%, #FF6F00 100%);
                border-radius:8px;
                line-height: 44px;
                text-align: center;
                margin: 36px auto 20px;
                color: #fff;
                font-size: 15px;
            }
        }
        .manageAddress{
            width: 280px;
            height: 194px;
            background-color: #F7F8FA;
            border-radius:10px;
            position: absolute;
            top: 50%;
            left: 50%;
            z-index: 1;
            margin: -97px 0 0 -140px;
            .title{
                font-size: 16px;
                color: #333;
                height: 60px;
                line-height: 60px;
                text-align: center;
                font-weight: bold;
            }
            textarea{
                width: 240px !important;
                height: 58px !important;
                margin: 0 auto;
                display: inherit;
                border:1px solid rgba(224,224,224,1);
                border-radius:4px;
                font-size: 15px;
                outline: none;
                padding: 4px;
                &:focus{
                    border:1px solid rgba(224,224,224,1) !important;
                }
            }
            .sureBtn{
                margin-top: 17px;
                color:#FF7C00;
                font-size: 15px;
                text-align: center;
                padding: 14px 0;
                border-top: 1px solid #E0E0E0;
                
            }
        }
        .importPass{
            width: 280px;
            height: 240px;
            background-color: #fff;
            border-radius: 8px;
            position: absolute;
            left: 50%;
            top: 50%;
            z-index: 2;
            margin-left: -140px;
            margin-top: -120px;
            .noImport{
                padding: 8px 13px 0;
            }
            p{
                font-size: 17px;
                color: #333;
                font-weight: bold;
                text-align: center;
                margin-top: 32px;
            }
            .wordBox{
                margin-top: 45px;
            }
        }
    }
</style>
<template>
    <div class="submitOrder">
        <div class="order_title">
            <div class="title">提交订单</div>
        </div>
        <div class="order_content">
            <ul class="address_box">
                <!-- <li class="topBg" :style="{backgroundImage: 'url('+topBg+')'}"></li> -->
                <img src="../../assets/img_top.png" alt="">
                <li class="name">{{userData.name}}&nbsp;&nbsp;<span>{{userData.phone}}</span></li>
                <li>收货地址：{{myAddress.address}}</li>
                <li class="remarkContent"><span v-if="remarks">备注：{{remarks}}</span><span style="color:#4343FF;" @click="changeRemarks">填写备注</span></li>
                <li class="revise"><span @click="changeAddress">修改地址</span></li>
            </ul>
            <div class="cOrderList" v-for="(item,index) in orderList" :key="index">
                <p class="name">{{item[0].supplier_name}}</p>
                <ul>
                    <li v-for="value in item" :key="value.id">
                        <div class="price_num">
                            <p class="needPay">应付 <span style="fontSize:12px;">￥</span><span style="font-wight:bold">{{userData.cloud_vip != 0?(value.vip_price*value.num).toFixed(2):(value.price*value.num).toFixed(2)}}</span></p>
                            <p><span style="fontSize:12px;">￥</span>{{userData.cloud_vip != 0?value.vip_price:value.price}}</p>
                            <p>x{{value.num}}</p>
                        </div>
                        <div class="pro_ipns" v-if="value.type == 'plank'">
                            <div class="img_Box"><img :src="(value.picture && value.picture.length)?value.picture[0].url+'?x-oss-process=image/resize,m_fill,h_88,w_88':''" alt=""></div>
                        </div>
                        <div class="pro_ipns">
                            <div class="img_Box" v-if="value.type != 'plank'"><img :src="value.picture?(value.picture[0].url?value.picture[0].url+'?x-oss-process=image/resize,m_fill,h_88,w_88':value.picture[0]+'?x-oss-process=image/resize,m_fill,h_88,w_88'):''" alt="暂无图片"></div>
                        </div>
                        <div class="infoList">
                            <div class="brand_sub"><span>{{value.brand}}</span>&nbsp;&nbsp;<span>{{value.substrate}}</span></div>
                            <div v-for="(tem,temIndex) in setAttributesName(value.part_type)" :key="temIndex"><span>{{tem.title}}：</span>{{tem.value ? tem.value : value[tem.option]}}</div>
                            <!-- <div><span>颜色：</span>{{value.color_name}}</div>
                            <div><span>厚度：</span>{{value.thick}}</div>
                            <div><span>工艺：</span>{{value.texture_method}}</div>
                            <div><span>钢板：</span>{{value.steel_plate}}</div> -->
                        </div>
                    </li>
                </ul>
                <div class="totalCount">
                    <span class="total_num">共{{countNum(index)}}件</span>
                    <p>小计：<span style="fontSize:12px;">￥</span><span>{{countPrice(index)}}</span></p>
                </div>
            </div>
            <div style="height:50px;width:100%"></div>
        </div>
        <div class="order_foot">
            <div>
                <span class="allNum">共{{userCheckedId.length}}件</span>
                <span>合计：</span>
                <span class="price">￥<span>{{userData.cloud_vip != 0?Number(vip_price).toFixed(2):Number(all_price).toFixed(2)}}</span></span>
                <span class="btn" @click="toPay">提交订单</span>
            </div>
        </div>
        <!-- 弹窗 -->
        <div class="Meng" v-if="payShow"></div>
        <div class="payBox" v-if="payShow">
            <div class="pay_title">
                <div class="noPay" @click="noPay"><img src="../../assets/icon_chacha.png" alt=""></div>
                <div>支付</div>
            </div>
            <div class="allPrice">￥<span>{{totalPrice}}</span></div>
            <div class="payWay">
                <van-radio-group v-model="payValue">
                        <van-cell title="微信支付" clickable @click="payValue = '2'">
                            <img src="../../assets/weixin.png" alt="">
                            <template #right-icon>
                                <van-radio name="2" />
                            </template>
                        </van-cell>
                        <!-- <van-cell v-if="!is_weixin" title="支付宝支付" clickable @click="payValue = '2'">
                            <img src="../assets/zhifu.png" alt="">
                            <template #right-icon>
                                <van-radio name="2" />
                            </template>
                        </van-cell>
                        <van-cell title="柜柜钱包支付" clickable @click="payValue = '3'">
                            <img src="../assets/img_logo.png" alt="">
                            <template #right-icon>
                                <van-radio name="3" />
                            </template>
                        </van-cell> -->
                </van-radio-group>
            </div>
            <div class="paySubmit" @click="surePay"><span>确认支付</span></div>
        </div>
        <div class="Meng" v-if="addressShow" @click="addressShow = false"></div>
        <div class="manageAddress" v-if="addressShow">
            <div class="title">更改地址</div>
            <textarea name="" id="" placeholder="请在此输入您要更改的地址" v-model='myAddress.address'></textarea>
            <div class="sureBtn" @click='sureChange'>确认更改</div>
        </div>

        <div class="Meng" v-if="remarksShow" @click="remarksShow = false"></div>
        <!-- 备注 -->
        <div class="manageAddress" v-if="remarksShow">
            <div class="title">填写备注</div>
            <textarea name="" id="" placeholder="请在此输入备注" v-model='remarks'></textarea>
            <div class="sureBtn" @click='sureRemarks'>确认</div>
        </div>
        <!-- <div class="MengI" v-if="passWordInput" @click="noImport"></div>
        <div class="importPass" v-if="passWordInput">
            <div class="noImport"><img @click="noImport" width="16" height="16" src="../assets/icon_chacha.png" alt="" srcset=""></div>
            <p>请输入支付密码</p>
            <div class="wordBox">
                <van-password-input
                :value="passWord"
                :error-info="errorInfo"
                :focused="showKeyboard"
                @focus="showKeyboard = true"
                />
            </div>
            <van-number-keyboard
            :show="showKeyboard"
            @input="onInput"
            @delete="onDelete"
            @blur="showKeyboard = false"
            />
        </div> -->
    </div>
</template>
<script src="https://res.wx.qq.com/open/js/jweixin-1.4.0.js" type="text/javascript" charset="utf-8"></script>
<script>
    import {Toast,RadioGroup,Radio,Cell,CellGroup} from 'vant'
    import { mapMutations, mapState } from 'vuex';
    import { handleOrder,beforeHeadleOrder,handleOrderList,handleAttributesName } from '../../util/processingData.js'
    export default {
        components:{
            Toast,
            RadioGroup,
            Radio,
            Cell,
            CellGroup
        },
        data(){
            return{
                saveAddress:'',
                topBg:require('../../assets/img_top.png'),
                order:[],
                uid:'',
                payShow:false,
                addressShow:false,
                remarksShow:false,
                remarks:'',
                payValue:'2',
                // userData:{},
                myAddress:{},
                totalPrice:0,
                passWordInput:false,
                passWord:'',
                errorInfo:'',
                showKeyboard:true,
                orderList:[],
                userCheckedId:[],
                all_price:0,
                vip_price:0,
                order_ids:[], //订单ids
                jump_url:''
            }
        },
        async mounted(){
            let nowLocation = location.host
            let pr = location.protocol
            this.jump_url = pr + '//' + nowLocation + '/cloudStorageMall.html#/order'
            console.log(this.jump_url)
            let queryData = this.$route.query
            this.userCheckedId = queryData.userCheckedId
            // 如果userCheckId不是数组，则定义一个数组
            if (!Array.isArray(this.userCheckedId)) {
                this.userCheckedId = [this.userCheckedId]
            }
            this.all_price = queryData.all_price
            this.vip_price = queryData.vip_price
            this.totalPrice = this.vip_price
            // this.userData = JSON.parse(localStorage.data)
            this.uid = this.userData.id
            // 订单里数据不为空，不用判断
            let local = JSON.parse(localStorage.getItem('shopCarInfo'))[this.uid]
            let orders = local.filter(x => {
                return this.userCheckedId.indexOf(String(x.id)) != -1
            })
            // 把商品按不同云仓分为不同订单
            this.order = orders
            // this.orderList = beforeHeadleOrder(orders)
            this.orderList = handleOrderList(orders)
            // 获取用户地址
            this.$get('/py/erp/get_address',{
                uid:this.userData.id,
                condition:'default'
            },res => {
                if(res.data.length){
                    this.myAddress = res.data[0]
                }
            })
        },
        computed:{
            ...mapState([
                'is_weixin'
            ]),
            setAttributesName(){
                return (type) =>{
                    return handleAttributesName(type)
                }
            },
            userData(){
                return this.$store.state.userInfo
            },
            countNum(){
                return (index) => {
                    let num = 0
                    this.orderList[index].forEach(item => {
                        num += item.num
                    })
                    return num
                }
            },
            countPrice(){
                return (index) => {
                    let totalPrice = 0
                    if(this.userData.cloud_vip != 0){
                        this.orderList[index].forEach(item => {
                            totalPrice += (item.num*item.vip_price)
                        })
                    }else{
                        this.orderList[index].forEach(item => {
                            totalPrice += (item.num*item.price)
                        })
                    }
                    
                    totalPrice = totalPrice.toFixed(2)
                    return totalPrice
                }
            }
        },
        methods:{
            ...mapMutations([
                'showNav'
            ]),
            changeAddress(){
                this.addressShow = true
            },
            changeRemarks(){
                this.remarksShow = true
            },
            sureRemarks(){
                console.log(this.remarks)
                this.remarksShow = false
            },
            sureChange(){
                if(this.myAddress.hasOwnProperty('id')&&this.myAddress.address){
                    this.$post('/py/erp/update_address',{
                        id:this.myAddress.id,
                        uid:this.userData.id,
                        name:this.myAddress.name,
                        phone:this.userData.phone,
                        address:this.myAddress.address,
                        default:1
                    },res => {
                        if(res.status == 1){
                            Toast.success('地址保存成功')
                        }else{
                            Toast('地址保存失败')
                        }
                        this.addressShow = false
                    })
                }else{
                    // 没有地址，填写地址不为空
                    if(this.myAddress.address){
                        this.$post('/py/erp/add_address',{
                            uid:this.userData.id,
                            name:this.userData.name,
                            phone:this.userData.phone,
                            address:this.myAddress.address,
                            default:1
                        },res => {
                            if(res.status == 1){
                                Toast.success('地址保存成功')
                                // 重新获取一次地址
                                this.$get('/py/erp/get_address',{
                                    uid:this.userData.id,
                                    condition:'default'
                                },res => {
                                    if(res.data.length){
                                        this.myAddress = res.data[0]
                                    }
                                })
                            }else{
                                Toast('地址保存失败')
                            }
                            this.addressShow = false
                        })
                    }
                    
                }
            },
            backCar(){
                this.$router.go(-1)
            },
            toPay(){
                if(!this.myAddress.hasOwnProperty('id') || !this.myAddress.address){
                    Toast.fail('请填写收货地址')
                    return
                }
                let JsonData = {
                    uid:this.uid,
                    address:this.myAddress.address,
                    phone_number:this.myAddress.phone, 
                    name:this.myAddress.name,
                    remark:this.remarks,
                    order_type: 3
                }
                JsonData.commodity_list = handleOrder(this.order)
                this.$post('/py/erp/create_cloud_order_new',JsonData,res => {
                    if(res.status == 1){
                        
                        // // 设置总价
                        this.totalPrice = Number(res.data.final_price).toFixed(2)
                        // 成功生成订单后，修改本地购物车
                        let localCar = JSON.parse(localStorage.shopCarInfo)[this.uid]
                        console.log('local and userCheckediD: ', this.userCheckedId, localCar);
                        let newCar = localCar.filter(item => {
                            return !this.userCheckedId.find((id) => {
                                return item.id == id;
                            })
                            // if(this.userCheckedId.indexOf(String(item.id)) == -1){
                            //     return item
                            // }
                        })
                        // 重新保存本地购物车
                        let nowCar = {}
                        nowCar[this.uid] = newCar
                        localStorage.shopCarInfo = JSON.stringify(nowCar)
                        this.order_ids = res.data.order_ids
                        // this.payShow = true
                        // 跳转订单页面
                        this.$router.push({
                            name: 'personalCenterOrders'
                        });
                    } else {
                        this.$message.error('提交失败，请检查提交参数');
                    }
                }, () => {
                    this.$message.error('网络异常，请稍后再试');
                })
            },
            noPay(){
                this.payShow = false
                this.showNav()
                this.$router.push({
                    path:`order`,
                    query:{
                        menuId:0
                    }
                })
            },
            surePay(){
                // console.log(nowLocation + '/cloudStorageMall.html#/order')
                console.log(this.jump_url)
                this.$post('/py/erp/create_payment_new',{
                    uid:this.userData.id,
                    pay_type:'html',
                    pay_way:'2',
                    oids:this.order_ids,
                    jump_url:this.jump_url
                },res => {
                    // console.log(res)
                    location.href = res.data.codeUrl
                })
                // if(this.payValue == '1'){
                //     Toast('开发中...');
                // }else if(this.payValue == '2'){
                //     Toast('开发中...');
                // }else if(this.payValue == '3'){
                //     this.passWordInput = true
                // }
            },
            noImport(){
                 this.passWordInput = false
            },
            onInput(key) {
                this.passWord = (this.passWord + key).slice(0, 6);
                if (this.passWord.length === 6) {
                    this.errorInfo = '密码错误';
                } else {
                    this.errorInfo = '';
                }
            },
            onDelete() {
                this.passWord = this.passWord.slice(0, this.passWord.length - 1);
            },
        }
    }
</script>